import { VALID_TLDS } from "./tlds";

// Matches HubSpot's form email validation so the frontend rejects what HubSpot
// would drop on submission. Beyond format, HubSpot checks the domain's TLD
// against the real IANA list — e.g. "h@jj.ndd" is well-formed but rejected
// because ".ndd" isn't a real TLD — so we do the same.
const FORMAT_RE =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export function isValidEmail(email: string): boolean {
  if (email.length === 0 || email.length > 254) return false;
  // No consecutive dots anywhere.
  if (email.includes("..")) return false;
  const at = email.lastIndexOf("@");
  if (at <= 0) return false;
  // Local part must not start or end with a dot.
  const local = email.slice(0, at);
  if (local.startsWith(".") || local.endsWith(".")) return false;
  if (!FORMAT_RE.test(email)) return false;
  // Domain must end in a real top-level domain.
  const domain = email.slice(at + 1);
  const tld = domain.slice(domain.lastIndexOf(".") + 1).toLowerCase();
  return VALID_TLDS.has(tld);
}
